/**
 * Return the string that represents the Heap user id.
 * Accurately detecting that Heap has been blocked may need more investigation if we ever rely on it.
 * The sample space to date is Firefox with uBlock Origin on a Mac. In that case, window.heap was an empty array.
 * @param {object} args - argument object
 * @param {boolean} [args.indicateFailure=true] - set to false if any failure should return undefined
 * @returns {string|undefined} - the Heap user id; undefined if Heap is absent; blocked message if blocked
 */
function getHeapUserId({ indicateFailure = true } = {}) {
    if (window.heap) {
        if (typeof window.heap.getUserId === 'function') {
            return window.heap.getUserId();
        } else {
            return indicateFailure
                ? '--blocked--'
                : undefined;
        }
    } else {
        return indicateFailure
            ? '--no heap--'
            : undefined;
    }
}

export default getHeapUserId;
